import script from "./GoalsMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoalsMenu.vue?vue&type=script&lang=ts&setup=true"

import "./GoalsMenu.vue?vue&type=style&index=0&id=22b8caba&lang=css"

const __exports__ = script;

export default __exports__